import { Box, Skeleton } from '@mui/material';

export const MenuListSkeleton = () => {
  const skeletonArray = Array(7).fill('');

  return (
    <Box sx={{ marginTop: '6px' }}>
      {skeletonArray.map((_, skeletonIndex) => (
        <Box sx={{ margin: ' 0 auto 4px auto', width: '98%' }} key={skeletonIndex}>
          <Skeleton sx={{ borderRadius: '8px' }} variant="rectangular" height={38} />
        </Box>
      ))}
    </Box>
  );
};
